import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

const AuthContext = createContext({});

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStoredData();
  }, []);

  const loadStoredData = () => {
    const storedUser = localStorage.getItem('@Jobson:user');
    const storedToken = localStorage.getItem('@Jobson:token');

    if (storedUser && storedToken) {
      api.defaults.headers.Authorization = `Bearer ${storedToken}`;
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  };

  const signIn = async (email, senha) => {
    try {
      const response = await api.post('/auth/login', { email, senha });
      const { token, user } = response.data;

      localStorage.setItem('@Jobson:token', token);
      localStorage.setItem('@Jobson:user', JSON.stringify(user));
      
      api.defaults.headers.Authorization = `Bearer ${token}`;
      setUser(user);

      return { success: true };
    } catch (error) {
      console.error('Erro no login:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Erro ao fazer login' 
      };
    }
  };

  const signOut = () => {
    localStorage.removeItem('@Jobson:token');
    localStorage.removeItem('@Jobson:user');
    delete api.defaults.headers.Authorization;
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      signIn,
      signOut,
      isAuthenticated: !!user,
      isSuperAdmin: user?.tipo === 'super_admin',
      isAdmin: user?.tipo === 'admin' || user?.tipo === 'super_admin',
      isSuporte: user?.tipo === 'suporte'
    }}>
      {children}
    </AuthContext.Provider>
  );
};
